// extracted by mini-css-extract-plugin
module.exports = {"BlogPost":"BlogPostSlug_BlogPost__3KZ6D","instagram-media":"BlogPostSlug_instagram-media__BlMHl"};